import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function VestDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("w-4.5 h-4.5", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.825 2.92505H5.47965C5.72827 2.92505 5.92965 3.1233 5.92965 3.36807V5.15299C5.92965 5.29475 6.02483 5.41968 6.1632 5.45934L8.35043 6.02396C8.4888 6.06383 8.58397 6.18854 8.58397 6.33053V14.636C8.58397 14.8786 8.38417 15.075 8.13802 15.075H6.80467C6.2964 15.075 5.80275 14.9076 5.40247 14.5992L4.1913 13.6665C3.67605 13.2695 3.375 12.6615 3.375 12.0176V3.36807C3.375 3.1233 3.57637 2.92505 3.825 2.92505Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.175 2.92505H12.5203C12.2717 2.92505 12.0703 3.1233 12.0703 3.36807V5.15299C12.0703 5.29475 11.9752 5.41968 11.8368 5.45934L9.64957 6.02396C9.5112 6.06383 9.41602 6.18854 9.41602 6.33053V14.6318C9.41602 14.8766 9.61762 15.075 9.86625 15.075H11.1706C11.6948 15.075 12.2042 14.9023 12.6171 14.5842L13.7812 13.6877C14.3138 13.2775 14.625 12.6489 14.625 11.983V3.36807C14.625 3.1233 14.4236 2.92505 14.175 2.92505Z"
        fill="currentColor"
      />
    </svg>
  );
}
